import React, {FC} from 'react'

export const TfaIcon: FC = () => (
  <svg width="45" height="45" viewBox="0 0 45 45">
    <defs>
      <circle id="mnopdaxdna" cx="22.5" cy="22.5" r="22.5" />
      <path
        id="xp1222dihc"
        d="M16 0c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1H7.999l-5.145 5.146c-.196.196-.512.196-.708 0-.093-.093-.146-.22-.146-.353V12H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h15z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-520 -550) translate(50 170) translate(420 240) translate(50 140)">
        <mask id="zq2m0jhm6b" fill="#fff">
          <use xlinkHref="#mnopdaxdna" />
        </mask>
        <use fill="#424C65" fillRule="nonzero" xlinkHref="#mnopdaxdna" />
        <rect
          width="23"
          height="38"
          x="6"
          y="18"
          fill="#426FE2"
          fillRule="nonzero"
          mask="url(#zq2m0jhm6b)"
          rx="3"
        />
        <rect
          width="23"
          height="38"
          x="11"
          y="11"
          fill="#78A7FF"
          mask="url(#zq2m0jhm6b)"
          rx="3"
        />
        <rect
          width="5"
          height="1"
          x="20"
          y="13"
          fill="#424C65"
          mask="url(#zq2m0jhm6b)"
          rx=".5"
        />
        <g mask="url(#zq2m0jhm6b)">
          <g transform="translate(14 20)">
            <path
              fill="#5B88FE"
              d="M16 2c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1H7.999l-5.145 5.146c-.196.196-.512.196-.708 0-.093-.093-.146-.22-.146-.353V14H1c-.552 0-1-.448-1-1V3c0-.552.448-1 1-1h15z"
            />
            <mask id="irncj46eqd" fill="#fff">
              <use xlinkHref="#xp1222dihc" />
            </mask>
            <use fill="#EAF7FF" xlinkHref="#xp1222dihc" />
            <ellipse
              cx="8.5"
              cy="2.5"
              fill="#FFF"
              mask="url(#irncj46eqd)"
              rx="12.5"
              ry="6.5"
            />
          </g>
        </g>
        <g fill="#4466C5" mask="url(#zq2m0jhm6b)">
          <path
            d="M.752 1.928l-.586.063c-.082.01-.156-.05-.165-.132-.004-.038.006-.075.028-.105l.348-.476L.03.803C-.02.736-.005.642.061.593.091.571.13.561.166.565l.586.064.238-.54c.033-.075.122-.11.198-.076.034.015.061.042.076.077l.238.539.586-.064c.082-.009.156.05.165.133.004.037-.006.075-.028.105l-.348.475.348.476c.05.067.035.16-.032.21-.03.021-.068.032-.105.027l-.586-.063-.238.539c-.033.076-.122.11-.197.077-.035-.015-.062-.043-.077-.077l-.238-.54zM4.335 1.928l-.585.063c-.083.01-.157-.05-.166-.132-.004-.038.006-.075.028-.105l.348-.476-.348-.475c-.049-.067-.034-.161.033-.21.03-.022.067-.032.105-.028l.585.064.238-.54c.034-.075.122-.11.198-.076.034.015.062.042.077.077l.237.539.586-.064c.083-.009.157.05.166.133.004.037-.006.075-.029.105l-.348.475.348.476c.05.067.035.16-.032.21-.03.021-.068.032-.105.027l-.586-.063-.237.539c-.034.076-.122.11-.198.077-.034-.015-.062-.043-.077-.077l-.238-.54zM7.919 1.928l-.586.063c-.082.01-.156-.05-.165-.132-.004-.038.006-.075.028-.105l.348-.476-.348-.475c-.05-.067-.035-.161.032-.21.03-.022.068-.032.105-.028l.586.064.237-.54c.034-.075.122-.11.198-.076.035.015.062.042.077.077l.238.539.586-.064c.082-.009.156.05.165.133.004.037-.006.075-.028.105l-.348.475.348.476c.049.067.034.16-.033.21-.03.021-.067.032-.104.027l-.586-.063-.238.539c-.033.076-.122.11-.198.077-.034-.015-.061-.043-.077-.077l-.237-.54zM11.502 1.928l-.586.063c-.082.01-.156-.05-.165-.132-.004-.038.006-.075.028-.105l.348-.476-.348-.475c-.049-.067-.034-.161.032-.21.03-.022.068-.032.105-.028l.586.064.238-.54c.033-.075.122-.11.198-.076.034.015.061.042.076.077l.238.539.586-.064c.082-.009.156.05.165.133.004.037-.006.075-.028.105l-.348.475.348.476c.05.067.035.16-.032.21-.03.021-.068.032-.105.027l-.586-.063-.238.539c-.033.076-.122.11-.197.077-.035-.015-.062-.043-.077-.077l-.238-.54z"
            transform="translate(16 25)"
          />
        </g>
      </g>
    </g>
  </svg>
)
